<template>
  <section id="pricing" class="py-5">
    <div class="container">
      <div class="text-center mb-5">
        <h2 class="fw-bold text-dark">Planes y Precios</h2>
        <p class="mt-2 fs-5 text-muted">Elige el plan que mejor se adapte a tus necesidades.</p>
        <p class="text-center text-muted mt-4">Precios ya tienen IVA. Planes diseñados para médicos privados, especialistas o generales.</p>
      </div>
      <div class="row justify-content-center g-4">
        <!-- Plan Básico -->
        <div class="col-lg-4 col-md-6">
          <div class="card h-100 shadow-sm border-light">
            <div class="card-header bg-white py-3 border-bottom-0">
              <h4 class="my-0 fw-normal text-center text-dark">Básico</h4>
            </div>
            <div class="card-body d-flex flex-column">
              <h1 class="card-title pricing-card-title text-center text-dark mb-4">$500<small class="text-muted fw-light"> MXN/mes</small></h1>
              <p class="text-center text-muted small mb-4">Acceso completo al sistema:</p>
              <ul class="list-unstyled mt-3 mb-4 text-center text-muted">
                <li><i class="bi bi-check-lg text-success me-1"></i>Gestión de médicos y pacientes</li>
                <li><i class="bi bi-check-lg text-success me-1"></i>Agenda y citas médicas</li>
                <li><i class="bi bi-check-lg text-success me-1"></i>Registro de consultas y notas médicas</li>
                <li><i class="bi bi-check-lg text-success me-1"></i>Firma autográfa digitalizada</li>
                <li><i class="bi bi-check-lg text-success me-1"></i>Antecedentes y tratamientos</li>
                <li><i class="bi bi-check-lg text-success me-1"></i>Panel de control médico</li>
                <li><i class="bi bi-check-lg text-success me-1"></i>Control de precios de consulta</li>
                <li><i class="bi bi-envelope text-info me-1"></i>Soporte básico por correo</li>
              </ul>
              <!-- <router-link to="/signup" class="btn btn-lg btn-outline-primary mt-auto">Empieza Gratis</router-link> -->
            </div>
          </div>
        </div>
        <!-- Plan Premium (Anual) -->
        <div class="col-lg-4 col-md-6">
          <div class="card h-100 shadow border-dark">
             <div class="card-header bg-white py-3 border-dark">
               <h4 class="my-0 fw-normal text-center text-dark">Premium <span style="background: #00E5B1; color: white; padding: 2px 8px; border-radius: 4px; font-size: 0.8em; vertical-align: middle;">Recomendado</span></h4>
             </div>
            <div class="card-body d-flex flex-column">
              <h1 class="card-title pricing-card-title text-center text-dark mb-4">$5,500<small class="text-muted fw-light"> MXN/año</small></h1>
              <p class="text-center text-success small fw-bold mb-1">¡Ahorra 8.33%!</p>
              <p class="text-center text-muted small mb-4">(Equivalente a 1 mes gratis)</p>
              <ul class="list-unstyled mt-3 mb-4 text-center text-muted">
                <li><i class="bi bi-star-fill text-warning me-1"></i><strong>Incluye todo lo de Básico</strong></li>
                <li><i class="bi bi-check-lg text-success me-1"></i>Acceso completo 12 meses</li>
                <li><i class="bi bi-headset text-info me-1"></i>Soporte prioritario</li>
                <li><i class="bi bi-shield-check text-success me-1"></i>Tranquilidad de un solo pago anual</li>
                <li><i class="bi bi-arrow-up-circle-fill text-success me-1"></i>Preferencia en futuras actualizaciones</li>
                <li><i class="bi bi-rocket-takeoff-fill text-success me-1"></i>Acceso anticipado a nuevas funciones</li>
                 <li class="small">(IA, Firma Digital, etc.)</li>
              </ul>
              <!-- <router-link to="/signup" class="btn btn-lg btn-primary mt-auto">Empieza Gratis Ahora</router-link> -->
            </div>
          </div>
        </div>
      </div>

      <p class="text-center mt-5 ">
        <strong>Prueba gratis por 14 días:</strong> accede a todas las funciones de nuestro software médico sin compromiso y descubre cómo optimizar la gestión de tu consultorio.
      </p>
      <div class="d-flex justify-content-center">
        <router-link to="/signup" class="btn btn-lg btn-primary mt-auto">Empieza Gratis Ahora</router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PricingSection'
}
</script>

<style scoped>
.card {
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}
.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important; /* Aumentar sombra en hover */
}

.card-header {
  border-bottom: 1px solid #dee2e6;
}

.pricing-card-title small {
  font-size: 65%;
}

.list-unstyled li {
  margin-bottom: 0.5rem; /* Add some spacing between list items */
  display: flex; /* Align icon and text */
  align-items: center;
  justify-content: center; /* Center items */
  text-align: left; /* Align text left within the flex item */
  padding-left: 1rem; /* Add padding for centering effect */
  padding-right: 1rem;
}

.list-unstyled li i {
  margin-right: 0.5rem; /* Space between icon and text */
}

/* Estilo específico para el plan recomendado */
.border-primary {
  border-width: 2px !important;
}

.card-header.bg-primary {
    background-color: var(--eb-primary) !important; /* Force background */
    color: var(--eb-dark) !important; /* Ensure text contrast */
}

.btn-primary {
    background-color: var(--eb-primary) !important; /* Force background */
    border-color: var(--eb-primary) !important; /* Force border */
    color: var(--eb-dark) !important; /* Ensure text contrast */
}

/* Hover/Active states for btn-primary if needed */
.btn-primary:hover {
    background-color: color-mix(in srgb, var(--eb-primary) 90%, white) !important;
    border-color: color-mix(in srgb, var(--eb-primary) 90%, white) !important;
    color: var(--eb-dark) !important;
}

.btn-primary:active {
    background-color: color-mix(in srgb, var(--eb-primary) 85%, black) !important;
    border-color: color-mix(in srgb, var(--eb-primary) 85%, black) !important;
    color: var(--eb-dark) !important;
}

</style>
